import { render, staticRenderFns } from "./OrganizeReady.vue?vue&type=template&id=4bd74978&scoped=true&"
import script from "./OrganizeReady.vue?vue&type=script&lang=js&"
export * from "./OrganizeReady.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeReady.vue?vue&type=style&index=0&id=4bd74978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd74978",
  null
  
)

export default component.exports